<div class="loader" *ngIf="isModuleLoading">
    <app-three-dots-blinking></app-three-dots-blinking>
</div>
<ng-container *ngIf="!isModuleLoading">
    <div class="header">
        <div class="reporting" (click)="navigateToRoute()">
            <img src="/assets/icons/arrow/back-icon.svg">
            <h4>{{'reporting.QUANTIFIED_REPORTING' | transloco}}</h4>
        </div>
        <h1>{{moduleDetail?.moduleName}}</h1>
        <div class="facts">
            <div class="assigned-members">
                <p>{{'reporting.ASSIGNED_USERS' | transloco}}</p>
                <h6>{{ noData ? 0 : moduleDetail?.assignedMembersInModule }} {{'reporting.USERS' | transloco}}</h6>
            </div>
            <div class="requirements" *ngIf="moduleDetail && moduleDetail.avgCompletionRequirement > 0">
                <p>{{'reporting.COMPLETION_REQUIREMENT' | transloco}}</p>
                <h6>{{'reporting.AVG_SCORE_Of' | transloco}} > {{ noData ? 0 : (moduleDetail.avgCompletionRequirement | number:'1.2-2') }}</h6>
            </div>
        </div>
    </div>
    <ng-container *ngIf="!noData">
        <div class="body" [class.expanded]="isExpanded">
            <div class="tab-wrapper" #tabWrapper>
                <div class="tabs" [class.border]="!isExpanded">
                    <ng-container *ngIf="isExpanded">
                        <div class="group">
                            <img src="/assets/icons/qc-logofull.svg">
                            <div (click)="navigateToRoute()" class="cursor-pointer">{{'reporting.REPORTING' | transloco}}</div>
                            <img src="/assets/icons/arrow/chevron-right-grey.svg">
                            <div>{{moduleDetail?.moduleName}}</div>
                        </div>
                    </ng-container>
                    <h4 *ngIf="certificationAssignmentCount > 0" [ngClass]="getTabClass('Certifications')"
                        (click)="setTab('Certifications')"><span>{{'reporting.CERTIFICATIONS' | transloco}}</span>
                    </h4>
                    <h4 *ngIf="practiceAssignmentCount > 0" [ngClass]="getTabClass('Practices')"
                        (click)="setTab('Practices')"><span>{{'reporting.PRACTICES' | transloco}}</span>
                    </h4>
                    <h4 [ngClass]="getTabClass('Content')" (click)="setTab('Content')"><span>{{'reporting.CALL_ANALYSIS' | transloco}}</span></h4>
                </div>
            </div>
        </div>
        <ng-container *ngIf="currentTab === 'Certifications' && certificationAssignmentCount > 0">
            <app-reporting-engagement [moduleName]="moduleDetail?.moduleName" [moduleUuid]="moduleUuid"
                (resultFetched)="maintainScrollPosition()"></app-reporting-engagement>
        </ng-container>
        <ng-container *ngIf="currentTab === 'Practices' && practiceAssignmentCount > 0">
            <app-reporting-practice [moduleName]="moduleDetail?.moduleName" [moduleUuid]="moduleUuid"
                (resultFetched)="maintainScrollPosition()"></app-reporting-practice>
        </ng-container>
        <ng-container *ngIf="currentTab === 'Content'">
            <app-reporting-content (resultFetched)="maintainScrollPosition()" [accountUuid]="accountUuid"
                [moduleUuid]="moduleUuid" [moduleName]="moduleName"
                [callTypesInModule]="callTypesInModule"></app-reporting-content>
        </ng-container>
    </ng-container>
</ng-container>